import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { timer } from 'rxjs';
import { ConfirmationDialog } from '../../../dialog';
import { StagingFromBackupModalComponent } from '../../../staging-from-backup/staging-from-backup-modal/staging-from-backup-modal.component';
import { StagingFromTemplateModalComponent } from '../../../staging-from-template/staging-from-template-modal/staging-from-template-modal.component';

@Component({
  selector: 'app-reset-staging-card',
  templateUrl: './reset-staging.component.html',
  styleUrls: ['./reset-staging.component.scss'],
  standalone: false,
})
export class ResetStagingComponent {
  @Output() resetRequest = new EventEmitter<null>();
  @Output() resetFromTemplateRequest = new EventEmitter<string>();
  @Output() createFromStagingRequest = new EventEmitter<null>();
  disableButton = false;

  constructor(private dialog: MatDialog) {}

  resetStaging(): void {
    this.disableButton = true;
    this.dialog
      .open(ConfirmationDialog, {
        data: {
          content: 'PAGES.STAGING.RESET_STAGING_MODAL.CONFIRMATION.TITLE',
          action: 'PAGES.STAGING.RESET_STAGING_MODAL.BUTTONS.CONFIRM',
          subtitle: 'PAGES.STAGING.RESET_STAGING_MODAL.CONFIRMATION.SUBTITLE',
        },
        disableClose: false,
        hasBackdrop: true,
      })
      .afterClosed()
      .subscribe((shouldReset: boolean) => {
        if (shouldReset) {
          this.resetRequest.emit(null);
          timer(10000).subscribe(() => (this.disableButton = false));
        } else {
          this.disableButton = false;
        }
      });
  }

  showStagingModal(): void {
    this.disableButton = true;
    this.dialog
      .open(StagingFromBackupModalComponent, {
        panelClass: ['staging-from-backup-modal'],
        minWidth: '800',
        width: '800',
        height: '600',
      })
      .afterClosed()
      .subscribe((resetting: boolean) => {
        if (resetting) {
          window.setTimeout(() => {
            this.disableButton = false;
          }, 10000);
        } else {
          this.disableButton = false;
        }
      });
  }
  showTemplateModal(): void {
    this.disableButton = true;
    this.dialog
      .open(StagingFromTemplateModalComponent, {
        panelClass: ['staging-from-template-modal'],
        maxHeight: '800px',
        minHeight: '600px',
        maxWidth: '4000px',
        minWidth: '700px',
      })
      .afterClosed()
      .subscribe((templateId: string) => {
        if (templateId) {
          this.resetFromTemplateRequest.emit(templateId);
          window.setTimeout(() => {
            this.disableButton = false;
          }, 10000);
        } else {
          this.disableButton = false;
        }
      });
  }
}
